interface Props {
  className?: string;
  barClassName?: string;
}

export const LoadingBar = (props: Props) => {
  return (
    <div
      className={`status-bar relative flex items-center h-1 justify-start bg-transparent overflow-hidden ${props.className}`}
    >
      <div
        className={`status-bar-animation absolute bottom-0 left-0 w-full h-full max-h-full first-letter:rounded-lg bg-blue-600 animate-move ${props.barClassName}`}
      ></div>
      <div className="status-bar-animation-background absolute bottom-0 left-0 w-full h-full max-h-full bg-transparent"></div>
    </div>
  );
};
